// LandingPage.js
import React from 'react';
import Hero from '../components/Hero';
import ParentCTA from '../components/ParentCTA';
import Features from '../components/Features';
import Showcase from '../components/Showcase';
// import CallToAction from '../components/CallToAction';
import Testimonials from '../components/Testimonials';
import Team from '../components/Team';
import Stats from '../components/Stats';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="bg-white text-gray-800">
      <Hero />
      <ParentCTA />
      <Stats />
      <Showcase />
      <Features />
      <Team />
      <Testimonials />
      {/* <CallToAction /> */}
      <Footer />
    </div>
  );
};

export default LandingPage;